// converts lowercase locales to the right format e.g. en_gb -> en-GB
export default function convertLocale(locale: string) {
  return locale.split('_')
    .map((part, index) => (index === 0 ? part.toLowerCase() : part.toUpperCase()))
    .join('-')
}
